export default __webpack_public_path__ + "static/media/technical-preview-badge.f88966a1.svg";